// library imports
import { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageContent, PageHeader, PageWrapper, PageContainer } from 'components/common/layout_element/LayoutElement';
import * as Constants from "_core/configs/Constants";

// User Component imports
import {Textarea, Row, Button, TextInput, Stack, Icon, Tooltip, Card, Tab, LoadingBox, List, CommonModal, HTMLRenderer, CircleGraph, ProgressBar, Uploader, FileDownLoadButton, Text} from "_core/components/common/UI";
import { DocsItem, InfoCard } from "components/common/parts";
import { setLoading, setMenuState, setErrorModal, setInitializeState } from "_core/slices/scene/SceneSlice";
import * as SceneConfig from "_core/configs/SceneConfig";
import { ReverseKeyValue } from "_core/utils/common";
import dataManagerInstance from "_core/managers/DataManager";
import { FormatDate } from "_core/utils/common";

import AdminExecEvaluationApi from "apis/AdminExecEvaluationApi";
import AdminEvaluationApi from "apis/AdminEvaluationApi";

// styles imports
import './AdminUserRagEvaluate.scss';

const AdminUserRagEvaluate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { tUser } = useSelector((store) => store.transaction);
    const { tAccount } = useSelector((store) => store.transaction);
    const { tAssetList } = useSelector((store) => store.transaction);
    const { initializeState } = useSelector((store) => store.scene);
    const { iConstantList } = useSelector((store) => store.master);

    const [tabDataList, setTabDataList] = useState([]);
    const [listLoading, setListLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [QADataList, setQADataList] = useState([]);
    const [accuracyRate, setAccuracyRate] = useState(null);
    const [questionCount, setQuestionCount] = useState(0);
    const [isFinished, setIsFinished] = useState(false);

    const [execEvaluateWaiting, setExecEvaluateWaiting] = useState(null);
    const [stopEvaluate, setStopEvaluate] = useState(false);
    const stopEvaluateRef = useRef(stopEvaluate);

    const [isTestDataWaiting, setIsTestDataWaiting] = useState(false);
    const pollingIntervalRef = useRef(null);
    const [testsetUrl, setTestsetUrl] = useState("");

    // stopEvaluate を常に最新の値に更新
    useEffect(() => {
        stopEvaluateRef.current = stopEvaluate;
    }, [stopEvaluate]);

    // コンポーネントアンマウント時にポーリング停止
    useEffect(() => {
        return () => {
            stopPolling();
        };
    }, []);

    const [ modalInfo , setModalInfo] = useState( {
        show: false,
        text: '',
        onClick: null,
    });

    const ExecAdminExecEvaluationApi = AdminExecEvaluationApi();
    const ExecAdminEvaluationApi = AdminEvaluationApi();

	const [displayDataList, setDisplayDataList] = useState({
        columsize: {
            question:8, 
            predicted_answer : 10,
            answer:10,
            references : 6,
            score: 2,
            eval_status:2,
        },
        title: {
            question: "質問",
            predicted_answer: "想定の回答",
            answer: "回答",
            references: "参照",
            score: "スコア",
            eval_status: "判定",
        },
        value: []
    });

    useEffect(() => {
        CreateEvaluationDataList(QADataList)

        if (QADataList && QADataList.length > 0)
        {
            setQuestionCount(QADataList.length)
        }
        else
        {
            setQuestionCount(0)
        }
    }, [QADataList, execEvaluateWaiting]);

    /**
     * 指定したIDが配列に含まれていなければ追加する
     * @param {number} id - 追加するID
     */
    const addId = (id) => {
        if (execEvaluateWaiting == null)
        {
            setExecEvaluateWaiting([id])
            return
        }

        setExecEvaluateWaiting((prevIds) => {
            // IDが含まれていなければ追加
            if (!prevIds.includes(id)) {
                return [...prevIds, id];
            }
            return prevIds;
        });
    };
    
    /**
     * 指定したIDが配列に含まれていれば削除する
     * @param {number} id - 削除するID
     */
    const removeId = (id) => {
        setExecEvaluateWaiting((prevIds) => {
            if (prevIds.length === 1 && prevIds.includes(id))
            {
                return null
            }

            // IDが含まれていれば削除
            return prevIds.filter((item) => item !== id);
        });
    };

    const CreateEvaluationDataList = () => {
        // List用データの生成
		const listData = {
            columsize: {
                question:8, 
                predicted_answer : 10,
                answer:10,
                references : 6,
                score: 2,
                eval_status:2,
            },
            title: {
                question: "質問",
                predicted_answer: "想定の回答",
                answer: "回答",
                references: "参照",
                score: "スコア",
                eval_status: "判定",
            },
            value: []
        }

        if (!QADataList || QADataList.length === 0)
        {
            setDisplayDataList(listData);
            return
        }

        // eval_statusが"1"の要素の数をカウント
        const countEvalStatus = QADataList.reduce((count, item) => {
            return (item.eval_status === "1" || item.eval_status === 1) ? count + 1 : count;
        }, 0);

        setAccuracyRate({accuracyCount: countEvalStatus, questionCount: QADataList.length})

		if(QADataList.length > 0) {		
			QADataList.forEach((qaData, index) => {
                const isloading = execEvaluateWaiting != null && execEvaluateWaiting.includes(index)

				// データの整形
				const assetData = {};
                const titleData = {};
                if (isloading)
                {
                    assetData.question = ( <div className="evaluate-list-loading loading width-full"></div> )
                    assetData.predicted_answer = ( <div className="evaluate-list-loading loading width-full"></div> )
                    assetData.answer = ( <div className="evaluate-list-loading loading width-full"></div> )
                    assetData.references = ( <div className="evaluate-list-loading loading width-full"></div> )
                    assetData.score = ( <div className="evaluate-list-loading loading width-full"></div> )
                    assetData.eval_status = ( <div className="evaluate-list-loading loading width-full"></div> )
                }
                else
                {

                    // そのまま使えるデータを入れる
                    assetData.question = (
                        <Stack className="flex-center width-full text-size-small">
                            <HTMLRenderer htmlContent={qaData.question}></HTMLRenderer>
                        </Stack>
                    );
                    assetData.predicted_answer = (
                        <Stack className="flex-center width-full text-size-small">
                            <HTMLRenderer htmlContent={qaData.predicted_answer}></HTMLRenderer>
                        </Stack>
                    )
                    assetData.answer = (
                        <Stack className="flex-center width-full text-size-small">
                            <div className="answer-date">{qaData.eval_date ? qaData.eval_date.replace("T", " ") : ""}</div>
                            <HTMLRenderer htmlContent={qaData.answer}></HTMLRenderer>
                        </Stack>
                    )
                    console.log(qaData.references);
                    assetData.references = (
                        <Stack className="flex-center width-full text-size-small spacing-16px">
                            {
                                // 常に配列として扱う（単一文字列は [string] に、未定義は空配列に）
                                (() => {
                                    const refs = Array.isArray(qaData.references)
                                        ? qaData.references
                                        : (qaData.references ? [qaData.references] : []);

                                    if (refs.length === 0) {
                                        return <div className="text-muted">参照なし</div>;
                                    }

                                    return refs.map((reference, idx) => {
                                        const label = (typeof reference === "string") ? reference : JSON.stringify(reference);
                                        return (
                                            <Card key={idx} className="references-card info-card">
                                                <div className="references-card-text width-full height-full">
                                                    {label}
                                                    <Tooltip className="tooltip-hidden" offset={0.01}>
                                                        {label}
                                                    </Tooltip>
                                                </div>
                                            </Card>
                                        );
                                    });
                                })()
                            }
                        </Stack>
                    )
                    assetData.score = (
                        <Stack className="flex-center align-center text-size-large text-bold">
                            {qaData.score}
                        </Stack>
                    );
                    assetData.eval_status = qaData.eval_status;
                    const eval_status_class = qaData.eval_status !== null ?  (qaData.eval_status == 1 ? "ok" : "ng") : "na"
                    const eval_status_label = qaData.eval_status !== null ?  (qaData.eval_status == 1 ? "OK" : "NG") : "-"
                    assetData.eval_status = (
                        <Row className="spacing-8px width-full height-full">
                            <Stack className={"status-item flex-center align-center width-full height-full " + eval_status_class}>
                                <Row className="spacing-4px">
                                    <div className="inter text-bold text-size-medium">{eval_status_label}</div>
                                </Row>
                            </Stack>
                        </Row>
                    );
                }

				// 各データのクリック時処理
				const onClick = () => {
				};

				// リスト用データの作成
				listData.value.push({
					data: assetData,
                    title: titleData,
					onclick: onClick
				});
			});
		}

		setDisplayDataList(listData);
    }

    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: false }));
    }, [dispatch]);
    
    useEffect(() => {
        if(initializeState !== Constants.INITIALIZE_STATE.allComplete)
        {
            return;
        }

        // 現在の状態を確認し、creating ならポーリング開始
        (async () => {
            await startPolling();
        })();

        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete));

    }, [initializeState]);

    const AdminExecEvaluationApiRequest = async () => {
        // テスト回数加算API
        const result = await ExecAdminExecEvaluationApi();

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
            // 処理を止める
            setStopEvaluate(true);
            stopEvaluateRef.current = true;
        }
        else
        {
        }
    };

    const ExecAdminEvaluationApiRequest = async (index, qaData) => {
        // テスト実行API
        const result = await ExecAdminEvaluationApi(qaData.question, qaData.predicted_answer);

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
            // 処理を止める
            setStopEvaluate(true)
            stopEvaluateRef.current = true;
        }
        else
        {
            qaData.answer = result.response.answer
            qaData.score = result.response.score
            // qaData.references = [result.response.reference]
            qaData.eval_status = (result.response.score > 80 ? 1 : 0)
            
            // 配列をコピーして、指定インデックスの要素を入れ替え
            const newQADataList = [...QADataList];
            newQADataList[index] = qaData;
            // 更新した配列をセット
            setQADataList(newQADataList);

            // テスト回数加算API実行
            await AdminExecEvaluationApiRequest();
        }
    };

    const ExecAllEvaluationAsync = () => {ExecAllEvaluation()}
    const ExecAllEvaluation = async () => {
        for (const [index, qaData] of QADataList.entries()) {
            // 停止された場合、処理を止めてループを抜ける
            if (stopEvaluateRef.current) 
            {
                console.log(stopEvaluate);
                console.log("処理を停止");
                setExecEvaluateWaiting(null)
                setStopEvaluate(false)
                return;
            }
            await ExecEvaluation(index, qaData);
        }
        setIsFinished(true)
    }

    const ExecEvaluation = async (index, qaData) => {
        addId(index);
        await ExecAdminEvaluationApiRequest(index, qaData);
        removeId(index);
    }

    const CSVDownload = (data, fileName) => {
        // CSVデータの作成
        const csvData = data;
    
        // 配列をCSV形式に変換
        const bom = "\uFEFF"; // UTF-8 BOM
        const csvContent = bom + csvData.map(row =>
            row.map(value => {
                // 値が入っていない場合はスキップする
                if (value == null) {
                    return "";
                }
                // 文字列に変換する
                const str = String(value);
                // 改行・カンマ・ダブルクォートが含まれていたら、全体をダブルクォートで囲む
                if (/[",\n]/.test(str)) {
                    // ダブルクォートは二重にする
                    return `"${str.replace(/"/g, '""')}"`;
                }
                return str;
            }).join(",")
        ).join("\r\n");
    
        // Blobを作成
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    
        // ダウンロード用URLを生成
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };

    // ポーリング処理: test_statusをチェック
    const pollTestStatus = async () => {
        try {
            const sid = dataManagerInstance.getSid();
            const response = await fetch(
                `${Constants.BASE_URL}/admin/test_status`,
                {
                    method: 'GET',
                    headers: {
                        'sid': sid,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.error_code > 0) {
                // エラーモーダル表示
                dispatch(setErrorModal({ show: true, text: result.error_detail }));
                stopPolling();
                setIsTestDataWaiting(false);
                setTestsetUrl("");
                return "error";
            }

            if (result.status === "downloadable") {
                // ダウンロード可能になった
                setIsTestDataWaiting(false);
                stopPolling();
                // ダウンロードURLを保持
                if (result.testset_sas_url) {
                    setTestsetUrl(result.testset_sas_url);
                }

                console.log("テストデータ作成完了");
            } else if (result.status === "creating") {
                console.log("テストデータ作成中...");
            } else {
                console.log("status:", result.status);
                stopPolling();
                setIsTestDataWaiting(false);
                setTestsetUrl("");
            }
            return result.status;
        } catch (error) {
            console.error("ポーリングエラー:", error);
            dispatch(setErrorModal({ 
                show: true, 
                text: {
                    code: "テスト状態取得エラー",
                    message: "テストデータの状態取得に失敗しました。"
                }
            }));
            stopPolling();
            setIsTestDataWaiting(false);
            setTestsetUrl("");
            return "error";
        }
    };

    // ポーリング開始
    const startPolling = async () => {
        console.log("テストデータ作成ジョブ開始");

        // 既存のポーリングを停止
        stopPolling();
        // 初回実行の結果に応じてinterval開始を制御
        const firstStatus = await pollTestStatus();
        if (firstStatus === "creating") {
            setIsTestDataWaiting(true);
            pollingIntervalRef.current = setInterval(() => {
                pollTestStatus();
            }, 5000);
        } else {
            stopPolling();
        }
    };

    // ポーリング停止
    const stopPolling = () => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    };

    const CSVDownloadExternal = async (requestUrl) => {
        await CSVDownloadExternalAsync(requestUrl)
    }
    const CSVDownloadExternalAsync = async (requestUrl) => {
        // ローディング表示をオン
        setIsTestDataWaiting(true);
        // 以前のダウンロードURLをクリア
        setTestsetUrl("");
        const sid = dataManagerInstance.getSid();
        
        try {
            const response = await fetch(requestUrl, {
                method: 'POST',
                headers: {
                    'sid': sid,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.error_code > 0) {
                // エラーモーダル表示
                dispatch(setErrorModal({ show: true, text: result.error_detail }));
                setIsTestDataWaiting(false);
                return;
            }

            if (result.status === "pending") {
                startPolling();
            } else {
                throw new Error("Invalid response format");
            }

        } catch (error) {
            console.error("テストデータ作成開始失敗:", error);
            dispatch(setErrorModal({ 
                show: true, 
                text: {
                    code: "テストデータ作成開始失敗",
                    message: error?.message ? `テストデータ作成の開始に失敗しました: ${error.message}` : "テストデータ作成の開始に失敗しました。"
                }
            }));
            setIsTestDataWaiting(false);
        }
    };

    // カラム対照表
    const columnMapping = {
        question: "質問",
        predicted_answer: "想定の回答",
        answer: "回答",
        references: "参照",
        score: "スコア",
        eval_status: "判定",
    };

    // ファイル読み込みとCSV処理
    const processCsvFile = (file, onComplete) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const csvText = e.target.result;
            const rows = parseCSV(csvText);
            const objects = mapToObjects(rows, columnMapping);
            console.log(objects);
            if (onComplete)
            {
                onComplete(objects)
            }
        };

        reader.onerror = (e) => {
            console.error("ファイル読み込み中にエラーが発生しました:", e);
        };

        reader.readAsText(file);
    }

    // 改行付きCSVをパースし、改行を含むセルを配列に変換
    function parseCSV(csvText) {
        const rows = [];
        let currentRow = [];
        let currentCell = '';
        let insideQuotes = false;

        for (let i = 0; i < csvText.length; i++) {
            const char = csvText[i];
            const nextChar = csvText[i + 1] || '';

            if (char === '"' && !insideQuotes) {
                // セル内のクォートを開始
                insideQuotes = true;
            } else if (char === '"' && insideQuotes && nextChar === '"') {
                // エスケープされたクォート
                currentCell += '"';
                i++; // 次のクォートをスキップ
            } else if (char === '"' && insideQuotes) {
                // セル内のクォートを終了
                insideQuotes = false;
            } else if (char === ',' && !insideQuotes) {
                // セルの終了
                currentRow.push(processCell(currentCell.trim()));
                currentCell = '';
            } else if (char === '\n' && !insideQuotes) {
                // 行の終了
                currentRow.push(processCell(currentCell.trim()));
                rows.push(currentRow);
                currentRow = [];
                currentCell = '';
            } else {
                // セル内の文字を追加
                currentCell += char;
            }
        }

        // 最後のセルを追加
        if (currentCell || currentRow.length > 0) {
            currentRow.push(processCell(currentCell.trim()));
            rows.push(currentRow);
        }

        return rows;
    }

    // セル内を処理して改行があれば配列に変換
    function processCell(cell) {
        if (cell.includes("\n")) {
            return cell.split("\n").map(line => line.trim());
        }
        return cell;
    }

    // CSVデータをkey: valueのリストに変換
    const mapToObjects = (rows, columnMapping) => {
        if (rows.length < 2) {
            return [];
        }

        const header = rows[0];
        const dataRows = rows.slice(1);

        // ヘッダー行からインデックスを取得
        const headerMapping = {};
        for (const [key, label] of Object.entries(columnMapping)) {
            const index = header.indexOf(label);
            if (index !== -1) {
                headerMapping[key] = index;
            }
        }

        // データ行をオブジェクトに変換
        return dataRows.map(row => {
            const obj = {
                question: "",
                predicted_answer: "",
                answer: "回答がありません。",
                references: [],
                score: "-",
                eval_status: null,
            };
            for (const [key, index] of Object.entries(headerMapping)) {
                obj[key] = row[index] || obj[key]; // データが不足している場合は空文字
            }
            
            return obj;
        });
    }

    // ファイルを処理する
    const changeCSV = (files) => {
        if (!files || files.length === 0)
        {
            return
        }

        const file = files[0].file; // 最初のファイルを使用
        processCsvFile(file, (objects) => {setQADataList(objects)});
    }

    useEffect(() => {
        changeCSV(files)
    }, [files]);

    const getResultData = () => {
        let resultDataList = [["質問", "想定の回答", "回答", "参照", "スコア", "判定"]]
        QADataList.forEach((qaData) => {
            let rowResult = []
            Object.values(qaData).forEach((columnData) => {
                if (Array.isArray(columnData)) {
                    rowResult.push(escapeCSVCell(columnData.join("\n")))
                } else {
                    rowResult.push(columnData)
                }
            })
            resultDataList.push(rowResult)
        })

        console.log(resultDataList);

        return resultDataList
    }

    const escapeCSVCell = (cell) => {
        if (typeof cell === "string" && (cell.includes(",") || cell.includes("\n") || cell.includes('"'))) {
            return `"${cell.replace(/"/g, '""')}"`; // ダブルクォートをエスケープ
        }
        return cell;
    };

    const buttonArea = () => {
        if (isFinished)
        {
            return (
                <Row className= "util-button-row width-full align-center spacing-16px flex-right align-bottom">
                    <Stack className="spacing-8px width-fit">
                        <div>テストデータ</div>
                        <div className="clipboard-area width-fit relative">
                            <TextInput 
                                className = "tag-input"
                                value={files[0].file.name} 
                                disabled={true}
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                            />
                            <Uploader
                                className={"width-fit primary" + (execEvaluateWaiting != null ? " disabled" : "")}
                                accept={Constants.ACCEPT_TEST_DATA_EXTENSION_LIST}
                                onFileChanged={(files) => {
                                    setIsFinished(false)
                                    setFiles(files)
                                }}
                                minimum={true}
                                buttonLabel={(
                                    <Row className="flex-center width-full spacing-8px">
                                        <Icon icon="arrow-repeat" size={20} className="copy-icon"/>
                                        <div>変更</div>
                                    </Row>
                                )}
                                buttonClass={"clipboard-button hidden "}
                                files={files}
                                isSwap={true}
                            />
                        </div>
                    </Stack>
                    <Stack className="spacing-32px align-center flex-bottom height-full">
                        <Button
                            className={"util-button width-fit primary"}
                            onClick={() => {
                                CSVDownload(getResultData(), "テスト結果データ")
                            }}
                        >
                            <Row className="flex-center width-fit spacing-8px">
                                <Icon className="label-icon" icon="download" size={24} />
                                <div>結果ダウンロード</div>
                            </Row>
                        </Button>
                    </Stack>
                </Row>
            )
        }

        if (files && files.length > 0)
        {
            return (
                <Row className= "util-button-row width-full align-center spacing-16px flex-right align-bottom">
                    <Stack className="spacing-8px width-fit">
                        <div>テストデータ</div>
                        <div className="clipboard-area width-fit relative">
                            <TextInput 
                                className = "tag-input"
                                default={files[0].file.name} 
                                disabled={true}
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                            />
                            <Uploader
                                className={"width-fit primary" + (execEvaluateWaiting != null ? " disabled" : "")}
                                accept={Constants.ACCEPT_TEST_DATA_EXTENSION_LIST}
                                onFileChanged={(files) => {
                                    setIsFinished(false)
                                    setFiles(files)
                                }}
                                minimum={true}
                                buttonLabel={(
                                    <Row className="flex-center width-full spacing-8px">
                                        <Icon icon="arrow-repeat" size={20} className="copy-icon"/>
                                        <div>変更</div>
                                    </Row>
                                )}
                                buttonClass={"clipboard-button hidden "}
                                files={files}
                                isSwap={true}
                            />
                        </div>
                    </Stack>
                    <Stack className="spacing-32px align-center flex-bottom height-full">
                        {execEvaluateWaiting != null ? 
                        <Button
                            className={"util-button width-fit hidden-border"}
                            onClick={() => {
                                console.log("処理を停止");
                                setStopEvaluate(true)
                            }}
                        >
                            <Row className="flex-center width-fit spacing-8px">
                                <Icon className="label-icon" icon="stop-fill" size={24} />
                                <div>中止</div>
                            </Row>
                        </Button>
                        :
                        <Button
                            className={"util-button width-fit primary"}
                            onClick={() => {
                                ExecAllEvaluationAsync()
                            }}
                        >
                            <Row className="flex-center width-fit spacing-8px">
                                <Icon className="label-icon" icon="play-fill" size={24} />
                                <div>実行</div>
                            </Row>
                        </Button>
                        }

                    </Stack>
                </Row>
            )
        }

        return (
            <Row className= "util-button-row width-full align-bottom spacing-16px flex-right">
                <Stack className="spacing-16px align-left flex-bottom height-fit">
                    <Button
                        className={"util-button width-fit secondary-border" + (isTestDataWaiting ? " disabled" : "")}
                        onClick={() => {
                            if (!isTestDataWaiting) {
                                CSVDownloadExternal((Constants.BASE_URL + "/admin/start_test_job"))
                            }
                        }}
                        disabled={isTestDataWaiting}
                    >
                        <Row className="flex-center width-fit spacing-8px">
                            <Icon className="label-icon" icon="file-earmark-check" size={24} />
                            <div>テストデータ作成</div>
                        </Row>
                    </Button>
                </Stack>
                <Stack className="spacing-32px align-center flex-bottom height-full">
                    <Uploader
                        className="width-fit primary"
                        accept={Constants.ACCEPT_TEST_DATA_EXTENSION_LIST}
                        onFileChanged={(files) => {
                            setIsFinished(false)
                            setFiles(files)
                        }}
                        minimum={true}
                        buttonLabel={(
                            (execEvaluateWaiting != null && execEvaluateWaiting.includes(0)) ? 
                            <Stack className="flex-center align-center">
                                <LoadingBox></LoadingBox>
                            </Stack>
                            :
                            <Row className="flex-center width-fit spacing-8px">
                                <Icon className="label-icon" icon="box-arrow-in-up-right" size={24} />
                                <div>テストデータ読み込み</div>
                            </Row>
                        )}
                        buttonClass={"util-button primary "}
                        files={files}
                        isSwap={true}
                    />
                </Stack>
            </Row>
        )
    }

    const graphArea = () =>{
        if (accuracyRate == null)
        {
            return (
                <Row className="rate-area flex-left align-center spacing-32px  height-fit">
                    <Stack className="flex-center align-center spacing-8px width-full">
                        <div className="text-size-large text-bold">正答率</div>
                    </Stack>
                    <Stack className="flex-center align-center width-full">
                        <div className="text-size-xx-large text-semibold">--%</div>
                        <div className="text-size-normal">-- / -- 問</div>
                    </Stack>
                    <Stack className="graph-area flex-center align-center spacing-8px width-full">
                        <CircleGraph
                            className="disabled"
                            rate={49}
                            radius={35}
                            thickness={3.8}
                        />
                        <Stack className="obj flex-center align-center">
                            <Icon className="label-icon" icon="check-all" size={24} />
                        </Stack>
                    </Stack>
                </Row>
            )
        }

        const rate = Math.round((accuracyRate.accuracyCount / accuracyRate.questionCount) * 100 * 100) / 100
        return (
            <Row className="rate-area flex-left align-center spacing-32px  height-fit">
                <Stack className="flex-center align-center spacing-8px width-full">
                    <div className="text-size-large text-bold">正答率</div>
                </Stack>
                <Stack className="flex-center align-center width-full">
                    <div className="text-size-xx-large text-semibold">{rate.toFixed(1)}%</div>
                    <div className="text-size-normal">{accuracyRate.accuracyCount} / {accuracyRate.questionCount} 問</div>
                </Stack>
                <Stack className="graph-area flex-center align-center spacing-8px width-full">
                    <CircleGraph
                        className=""
                        rate={rate}
                        radius={35}
                        thickness={3.8}
                    />
                    <Stack className="obj flex-center align-center">
                        <Icon className="label-icon" icon="check-all" size={24} />
                    </Stack>
                </Stack>
            </Row>
        )
    }

    return (
    <PageContent pageId="AdminUserRagEvaluate">
            <PageHeader>
                <Stack className="spacing-4px">
                    <div className="page-header-title">RAG応答テスト</div>
                    <div className="page-header-detail">{Constants.AI_NAME}のRAGを使用した応答を一括でテストできます。</div>
                </Stack>
            </PageHeader>
            <PageWrapper>
                <PageContainer>
                    {/* ここにページ内コンテンツのコンポーネントを記述 */}
                    <div className="block-center">
                        <Card className="base-card">
                            <Stack className="spacing-32px">
                                {/* 機能ヘッダー部分 */}
                                <Row className="util-row flex-both align-center spacing-8px height-fit">
                                    {graphArea()}
                                    <Stack className="button-area spacing-16px align-right height-full">
                                        <Row className= "width-fit align-bottom spacing-16px flex-left">
                                            {testsetUrl && (
                                                <Button className={"operate-button secondary-border success width-240px"} onClick={() => {
                                                        const link = document.createElement('a');
                                                        link.href = testsetUrl;
                                                        link.target ="_blank"
                                                        link.click();
                                                    }}>
                                                    <Row className="text-size-normal text-normal-weight operate-label spacing-4px">
                                                        <Icon className="label-icon" icon="download" size={24} />
                                                        <div>テストデータダウンロード</div>
                                                    </Row>
                                                </Button>
                                            )}
                                            <Stack className="width-280px spacing-8px align-center flex-bottom height-full">
                                                <Row className= "width-full align-center flex-both">
                                                    <Stack className="flex-bottom height-full">
                                                        テスト実行件数
                                                    </Stack>
                                                    <Row className="flex-right height-full align-bottom">
                                                        <div className="value-text text-size-large text-semibold height-fit">
                                                            {
                                                                (files && files.length > 0)
                                                                ? questionCount.toLocaleString()
                                                                : "--"
                                                            }
                                                        </div>
                                                    </Row>
                                                </Row>
                                                <ProgressBar progress={0} subProgress={0}></ProgressBar>
                                            </Stack>
                                        </Row>
                                        {/* ボタン表示エリアは状態によって変わるため取得する */}
                                        {buttonArea()}
                                    </Stack>
                                </Row>
                                <Stack className= "list-area align-center spacing-16px width-full">
                                    {QADataList && QADataList.length > 0 ?
                                        <List
                                            list={displayDataList}
                                            header={true}
                                            scrollbar={"scrollbar"}
                                            className="width-full"
                                            isLoading={((initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) || listLoading ) ? true : false}
                                            loadingCount={2}
                                        />
                                    :
                                        <Stack className="empty-state flex-center align-center">
                                            {isTestDataWaiting ?
                                                // テストデータ生成中
                                                <Card className="loading-modal-window solid-card ">
                                                    <Row className="flex-center align-center spacing-16px">
                                                        <LoadingBox className="loading-modal-spinner"></LoadingBox>
                                                        <Stack className="flex-center align-left ">
                                                            <Text>テストデータを作成しています。しばらくお待ちください。</Text>
                                                            <Text>学習データ量によって、完了まで数時間かかることがあります。</Text>
                                                        </Stack>
                                                    </Row>
                                                </Card>
                                            :
                                                <InfoCard>テストデータを読み込むと内容が表示されます。</InfoCard>
                                            }
                                        </Stack>
                                    }
                                </Stack>
                            </Stack>
                        </Card>
                    </div>
                </PageContainer>
                <CommonModal modalInfo={modalInfo} setModalInfo={setModalInfo}></CommonModal>
            </PageWrapper>
    </PageContent>
    );
};

export default AdminUserRagEvaluate;